import React, { Component } from "react";

export default class WorkPlay extends Component {
  render() {
    return (
      <section className="section-workplay parallax">
        <div className="row">
          <div className="col-sm-12">
            <div className="text-box-bg-image">
              <h1>
                OUR WORK IS OUR PLAY
                JUMP IN AND EXPERIENCE
                THE FUN
              </h1>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
